"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentlyAdding = void 0;
var CurrentlyAdding;
(function (CurrentlyAdding) {
    CurrentlyAdding["NONE"] = "NONE";
    CurrentlyAdding["GOOGLE"] = "GOOGLE";
    CurrentlyAdding["UPLOAD"] = "UPLOAD";
    CurrentlyAdding["URLS"] = "URLS";
    CurrentlyAdding["ONEDRIVE"] = "ONEDRIVE";
    CurrentlyAdding["SHAREPOINT"] = "SHAREPOINT";
    CurrentlyAdding["WEBSITE"] = "WEBSITE";
    CurrentlyAdding["CONFLUENCE"] = "CONFLUENCE";
})(CurrentlyAdding || (exports.CurrentlyAdding = CurrentlyAdding = {}));
